import gql from "graphql-tag";
import Constants from "../../Constants/Constants";

export const GET_PURCHASE_REQUEST_BY_ID = gql`
query getPurchaseRequestById($id: uuid!){
  PurchaseRequest(where: { id: {_eq: $id}}){
    id    
    productId
    vendorId
    statusId    
    cartoons
    qtyPerCartoon   
    rate
    totalQty    
    productType
    transportation
    requestedDate
    orderedDate
    deliveryDate
    createdBy
    created_at
    requestedDate
  }
}`

export const GET_PURCHASE_REQUEST_BY_PRODUCT_ID = gql`
query getPurchaseRequestByProductId($productId: uuid!){
  confirmedPurchaseRequest: PurchaseRequest(where: { productId: {_eq: $productId}, statusId: {_in: ["${Constants.PRQStatuses.Confirmed}","${Constants.PRQStatuses.Received}"]}},
        order_by: {created_at: desc}, limit: 1) {
    id
    Vendor {id name vendorCode profileImage}
    orderedDate
    receivedDate
    rate
  }
  PurchaseRequest(where: { productId: {_eq: $productId}}, order_by: {created_at: desc}, limit: 50) {
    id
    Vendor {id name vendorCode profileImage}
    statusId
    orderedDate   
    rate
    cartoons
    qtyPerCartoon
  }
}`

export const GET_PRODUCT_AND_VENDOR_BY_THEIR_ID = gql`
query getProductAndVendorByTheirId($productId: uuid!, $vendorId: uuid!){
  Products(where: { id: {_eq: $productId}}){
    id
    name
    cartonQty
    purchasePrice
    Attachments(where: {type: {_eq:"IMAGE"}, isDefault: {_eq:true}}) {id path}
  }
  Vendors(where: { id: {_eq: $vendorId}}){
    id
    name
    vendorCode
    profileImage
    transportation
  }
}`
